module.exports = __webpack_public_path__ + "static/media/logo.4309b5e0.png";